import { render, staticRenderFns } from "./CreateUniversityPage.vue?vue&type=template&id=07bad84e&scoped=true&"
import script from "./CreateUniversityPage.vue?vue&type=script&lang=js&"
export * from "./CreateUniversityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bad84e",
  null
  
)

export default component.exports